export default {
  'nav.home': 'Главная',
  'nav.guide': 'YOYBUY Spreadsheet Гайд',
  'nav.kaspreadsheet': 'Kaspreadsheet',
  'hero.title': 'YOYBUY Spreadsheet',
  'hero.subtitle': 'Умный шоппинг из Китая',
  'hero.description': 'Покупайте модную одежду, обувь и аксессуары из Китая проще, чем когда-либо. Ваш персональный spreadsheet-агент для безопасного шоппинга.',
  'cta.yoybuySheet': 'YOYBUY Sheet',
  'cta.buyItNow': 'Buy It Now',
  'categories.title': 'Вся мода из Китая',
  'categories.subtitle': 'В одной таблице',
  'categories.description': 'Выберите категорию и начните шоппинг прямо сейчас',
  'categories.view': 'Смотреть',
  'about.tag': 'Почему выбирают YOYBUY Spreadsheet',
  'articles.title': 'SEO Гайды',
  'articles.subtitle': 'YOYBUY',
  'testimonials.tag': 'Отзывы',
  'testimonials.title': 'Отзывы пользователей',
  'testimonials.subtitle': 'О шоппинге с YOYBUY',
  'footer.brand': 'YOYBUY Sheet',
  'footer.description': 'Ваш надёжный гид в мире шоппинга из Китая. Подписывайтесь на новости и получайте лучшие предложения первыми.',
  'footer.emailPlaceholder': 'Ваш email',
  'footer.subscribe': 'Подписаться',
  'footer.nav': 'Навигация',
  'footer.contacts': 'Контакты',
  'footer.address': 'Адрес',
  'footer.copyright': '© 2026 YOYBUY Beauty. Все права защищены.',
  'notfound.title': 'Страница не найдена',
  'notfound.description': 'Возможно, страница была удалена или адрес введён неверно.',
  'notfound.backHome': 'Вернуться на главную',
};